import React from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import resistance2 from "../Assets/Image/Resistence2.jpg";
import image1 from "../Assets/Image/braid1.jpeg";
import image2 from "../Assets/Image/braid2.jpeg";
import image3 from "../Assets/Image/braid3.jpeg";
import image4 from "../Assets/Images/braid4.jpeg";
import { Helmet } from "react-helmet";

const ResistanceWeldedFlexibles = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Copper Braided Flexible Connectors | Delta Engineering</title>
        <meta
          name="description"
          content="Durable, low-resistance copper connectors engineered for heavy-duty electrical applications. Copper Braided Flexible Connectors ensure maximum power delivery with minimal resistance."
        />
        <meta
          name="keywords"
          content="Copper Braided Flexible Connectors, Braided Flexibles, Earthing Jumpers, Copper Laminated Expansion Connectors, Copper Busbars, Electrical Connectors"
        />

        {/* Open Graph / Facebook */}
        <meta
          property="og:title"
          content="Copper Braided Flexible Connectors"
        />
        <meta
          property="og:description"
          content="Durable, low-resistance copper connectors engineered for heavy-duty electrical applications. Designed for switchgear, transformers, EVs, and renewable power plants."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/copper-braided-flexible-connectors"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/braid1.jpeg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Copper Braided Flexible Connectors"
        />
        <meta
          name="twitter:description"
          content="High-quality copper braided connectors for switchgear, EVs, renewable plants, and more."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/braid1.jpeg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <span className="blue-text">Copper Braided</span>{" "}
                <span className="white-text">Flexible Connectors</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                Durable, low-resistance copper connectors engineered for
                heavy-duty electrical applications.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-3 bg-light pt-2" style={{ position: "relative" }}>
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <div className="text-center mb-5">
            <h3 className="fw-bold section-title position-relative d-inline-block">
              Copper Braided Flexible Connectors
              <span className="title-underline"></span>
            </h3>
          </div>

          <Row>
            <Col>
              <p
                className="text-muted"
                style={{ lineHeight: "1.8", textAlign: "justify" }}
              >
                We supply Copper Braided Flexible Connectors and earthing
                braided products designed for the transmission of electrical
                currents ranging from low to high amperages. These connectors
                compensate for vibration, heat expansion, and contraction in
                busbars, ensuring maximum power delivery with minimal resistance
                and peak efficiency.
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-5">
            <Col md={6}>
              <Image
                src={resistance2}
                alt="Flat resistance welded connector"
                fluid
                rounded
                style={{ height: "300px", objectFit: "cover" }}
              />
            </Col>
            <Col md={6}>
              <h5 className="fw-bold">Braided Flexibles Connectors</h5>
              <p className="text-muted" style={{ textAlign: "justify" }}>
                Constructed using high purity and high conductivity copper
                wires. Ideal for compact switchgear and panel installations. Its
                low-profile design ensures maximum current flow in limited
                spaces without compromising flexibility or durability.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5">
        <Container>
          <Row className="align-items-start">
            <Col md={7}>
              <h5 className="fw-bold mt-4">Braids</h5>
              <ul className="text-muted" style={{ lineHeight: "1.8" }}>
                <li>Made out of annealed Cu-ETP wires</li>
                <li>
                  Copper wires uncoated is standard; tin or silver coated
                  available on request
                </li>
                <li>Wire diameter range: 0.07 mm – 0.20 mm</li>
              </ul>

              <h5 className="fw-bold mt-4">Contact Area</h5>
              <ul className="text-muted" style={{ lineHeight: "1.8" }}>
                <li>Seamless Cu-ETP tube</li>
                <li>
                  Available in uncoated tin, hot-dipped tin, or silver-coated
                  finish
                </li>
              </ul>

              <h5 className="fw-bold mt-4">Insulation</h5>
              <ul className="text-muted" style={{ lineHeight: "1.8" }}>
                <li>
                  Options include heat-shrinking tubes, silicon, or PVC on
                  request
                </li>
              </ul>

              <h5 className="fw-bold mt-4">Product Range</h5>
              <ul className="text-muted" style={{ lineHeight: "1.8" }}>
                <li>Copper Braided Flexible Connectors</li>
                <li>Earthing Tapes / Earthing Jumpers</li>
                <li>Copper Laminated Expansion Connectors</li>
                <li>Customized Copper Products</li>
              </ul>

              <h5 className="fw-bold mt-4">Technical Data</h5>
              <ul className="text-muted" style={{ lineHeight: "1.8" }}>
                <li>Current capacity: 10 Amps to 6300 Amps</li>
                <li>
                  Available in flat flexible strip, round flexible rope, and
                  stranded conductors
                </li>
                <li>Single or multiple cable terminations possible</li>
              </ul>

              <h5 className="fw-bold mt-4">Key Features</h5>
              <ul className="text-muted" style={{ lineHeight: "1.8" }}>
                <li>
                  Minimal contact resistance with excellent current transfer
                </li>
                <li>
                  High flexibility for absorbing vibrations and thermal
                  expansions
                </li>
                <li>Plating options: Tin, Silver, Nickel</li>
                <li>Customizable in U, V, Z, or S shapes with drilled holes</li>
                <li>
                  Manufactured from electrolytic copper (as per requirement)
                </li>
              </ul>
            </Col>
            <Col md={5}>
              <Row className="g-3">
                {[image1, image2, image3, image4].map((img, idx) => (
                  <Col xs={12} key={idx}>
                    <img
                      src={img}
                      alt={`Braided Connector ${idx + 1}`}
                      className="img-fluid rounded shadow-sm small-img"
                    />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5 bg-light">
        <Container>
          <h3 className="fw-bold mb-4 text-center">Applications</h3>
          <Row className="justify-content-center">
            <Col md={10}>
              <ul className="text-muted" style={{ lineHeight: "1.8" }}>
                <li>Switchgear and distribution panels</li>
                <li>Power transformers and reactors</li>
                <li>Battery packs in electric vehicles (EVs)</li>
                <li>Railway traction and metro systems</li>
                <li>Welding equipment and robotic arms</li>
                <li>Renewable energy power plants (solar, wind)</li>
                <li>Heavy industries with vibration or thermal cycles</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ResistanceWeldedFlexibles;
